import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Observable, takeUntil } from "rxjs";
import { IColumn } from "src/app/shared/models/table/column.interface";
import { BaseComponent } from "src/app/base.component";
import { select, Store } from "@ngrx/store";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  resultLoadingRemunerationSelector,
  resultRemunerationDetailsSelector,
  successMessageSelector,
} from "src/app/store/locationPartner/location-partner.selectors";
import { AdvertisingCampaignInterface } from "src/app/shared/models/advertising-campaigns/advertising-campaign.interface";
import { FormBuilder, FormGroup } from "@angular/forms";
import { PaymentFrequency } from "src/app/shared/enum/payment-frequency";
import { LocationPartnerInterface } from "src/app/shared/models/location-partners/locationPartner.interface";
import {
  ActionInterface,
  ActionReturned,
  OptionActionEnum,
  paymentLP,
} from "src/app/shared/data/actions-data";
import { UpdatePaymentStatusComponent } from "./update-payment-status/update-payment-status.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  FilterInterface,
  paymentLPFilter,
} from "src/app/shared/data/filter-data";
import {
  PaymentStatus,
  PaymentStatusToShow,
} from "src/app/shared/enum/paymentStatus";
import { BadgeService } from "src/app/shared/services/badge.service";
import {
  invokeRemunerationDetails,
  resultSuccess,
} from "src/app/store/locationPartner/location-partner.action";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { Authorities } from "src/app/shared/enum/authorities";
import { JwtService } from "src/app/shared/services/jwt.service";
import { FiltersService } from "src/app/shared/services/filters.service";
import { FilterParams } from "src/app/shared/models/filterParams";
import { Constants } from "src/app/shared/data/constants";
import { RemunerationEnum } from "src/app/shared/enum/renumeration.enum";
import { PaymentDetails } from "src/app/shared/models/franchise/paymentDetails.interface";
import { FranchisesRemunerationWithResultDto } from "src/app/shared/models/franchise/franchisesRemunerationWithResultDto.interface";
import { RemunerationDetailsResponse } from "src/app/shared/models/franchise/remunerationDetailsResponse.interface";
import { RemunerationFilterDto } from "src/app/shared/models/franchise/remunerationFilterDto.interface";
import { RefreshButtonState } from "src/app/shared/enum/refreshButtonState";
import { PartnerStatus } from "src/app/shared/enum/partner-status";
import { UtilFunctions } from "src/app/utils/utilFunctions";
import { AdvertisingCampaignRemunerationDetails } from "src/app/shared/models/advertising-campaigns/advertisingCampaignRemunerationDetails.interface";
import { invokeApiDistroyed } from "src/app/store/apiState.interface";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-payment",
  templateUrl: "./payment.component.html",
})
export class PaymentComponent extends BaseComponent implements OnInit {
  columns: IColumn[] = [
    {
      key: "endPilotePhase",
      label: "admin.locations.repository.endPhase",
      sorter: true,
    },
    {
      key: "prix",
      label: "admin.locations.payment.price",
      sorter: true,
    },
    {
      key: "titre",
      label: "admin.locations.campaigns.campaignName",
      sorter: true,
    },
    {
      key: "startDate",
      label: "admin.locations.payment.campaignStartDate",
      sorter: true,
    },
    {
      key: "endDate",
      label: "admin.locations.payment.campaignEndDate",
      sorter: true,
    },
    {
      key: "impression",
      label: "admin.locations.payment.impressionsNumber",
      sorter: true,
    },
    {
      key: "ht",
      label: "admin.locations.payment.totalTTC",
      sorter: true,
    },
  ];
  pageSize: number = Constants.defaultTableSize;
  pageNumber: number = 1;

  rowSpan: number = 1;

  allCompanyNames: string[] = [];
  formFilter: FormGroup;

  count: number;
  options: ActionInterface[] = paymentLP;
  filterPayment: FilterInterface = paymentLPFilter;
  isPaid: boolean | null = null;

  advertisingCampaigns: AdvertisingCampaignInterface[][] = [];
  locationPartners: LocationPartnerInterface[];
  loading$: Observable<boolean | null>;
  loading: boolean | null = true;
  updatePaymentStatus$: Observable<SuccessDto | null>;
  paymentStatusSuccessfullyUpdated: string;
  forbidden: boolean | null = false;

  filters: FilterParams | null;

  remunerationDetails$: Observable<FranchisesRemunerationWithResultDto | null>;
  remunerationDetails: RemunerationDetailsResponse[] = [];

  remunerationFilter: RemunerationFilterDto = {
    companyName: "",
    endDate: null,
    isPaid: null,
    pager: {
      pageNumber: 1,
      pageSize: Constants.defaultTableSize,
    },
    startDate: null,
  };

  paymentFrequency = PaymentFrequency;

  remunerationEnum = RemunerationEnum;

  paymentDetails: PaymentDetails = {
    nextPayment: 0,
    totalFinishedCampaigns: 0,
    totalFranchised: 0,
    totalViews: 0,
  };

  paymentDetails$: Observable<PaymentDetails | null>;

  loadingPayment: boolean = true;

  cachedAt: Date | null;
  fetchingHistoryState: RefreshButtonState = RefreshButtonState.IDLE;
  constructor(
    private store: Store<AppStateInterface>,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public badgeService: BadgeService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private saveHistory: SaveUserHistoryService,
    private jwtService: JwtService,
    private filtersService: FiltersService,
    private datePipe: DatePipe
  ) {
    super(store);
    this.remunerationDetails$ = this.store
      .pipe(select(resultRemunerationDetailsSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.loading$ = this.store
      .pipe(select(resultLoadingRemunerationSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.updatePaymentStatus$ = this.store
      .pipe(select(successMessageSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.formFilter = this.fb.group({
      companyName: [""],
      date: [[null, null]],
    });
    const authorities = this.jwtService.getPermissions(jwtService.getToken());
    if (authorities) {
      this.forbidden = !authorities.includes(
        Authorities.LP_PAYMENT_GETALL.toString()
      );
    }

    this.extractFilters();
  }

  extractFilters() {
    this.filters = this.filtersService.decodeUri();
    if (this.filters) {
      this.remunerationFilter.isPaid =
        this.findOption(this.filters.status) ?? null;
    }
    this.pageNumber = this.filtersService.extractValueFromUrl(
      this.filters,
      "page",
      this.pageNumber
    );
    this.pageSize = this.filtersService.extractValueFromUrl(
      this.filters,
      "size",
      this.pageSize
    );

    this.filtersService.patchFormValue(
      this.filters,
      ["companyName", "date"],
      this.formFilter
    );
    this.remunerationFilter = {
      ...this.remunerationFilter,
      companyName: this.formFilter.get("companyName")?.value || null,
      startDate: this.formFilter.get("date")?.value[0],
      endDate: this.formFilter.get("date")?.value[1],
    };
  }

  ngOnInit(): void {
    this.filterData(false);
    this.remunerationDetails$.subscribe((result) => {
      if (result) {
        this.cachedAt = result.cachedAt;
        this.remunerationDetails = result.remunerationDetails;
        this.count = result.count;
      }
    });

    this.updatePaymentStatus$.subscribe((result: SuccessDto | null) => {
      if (result != null) {
        this.paymentStatusSuccessfullyUpdated = result.message;
        this.modalService.dismissAll();
        if (this.paymentStatusSuccessfullyUpdated != "") {
          this.toastr.success(
            this.translate.instant(
              "response.success." + this.paymentStatusSuccessfullyUpdated
            ),
            this.translate.instant("response.successTitle")
          );
          this.filterData(false);
          this.saveHistory.saveUserHistory(
            UserHistoryActionsEnum.POST,
            UserHistoryServicesEnum.PAYMENT_LOCATION
          );
          this.store.dispatch(resultSuccess({ successMessage: null }));
        }
      }
    });
    this.filterPayment.name.map(
      (e) =>
        (e.data = Object.keys(PaymentStatus)
          .filter((value) => isNaN(Number(value)) === true)
          .map(
            (key: string | any) =>
              PaymentStatusToShow[key as keyof typeof PaymentStatus]
          ))
    );
    this.loading$.subscribe((data) => {
      this.loading = data;
    });

    this.formFilter.valueChanges.subscribe((values) => {
      this.pageNumber = 1;
      this.pageSize = Constants.defaultTableSize;
      this.count = 0;
      this.remunerationFilter = {
        ...this.remunerationFilter,
        startDate: values.date[0],
        endDate: values.date[1],
        pager: {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        },
        companyName:
          values.companyName.trim() === "" ? null : values.companyName,
      };
      this.filterData(false);
    });

    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.GET,
      UserHistoryServicesEnum.REMUNERATION_LP
    );
  }

  filterData(refreshCache: boolean) {
    this.store.dispatch(invokeApiDistroyed());
    if (refreshCache) {
      this.loading$.subscribe((isLoading) => {
        if (isLoading) {
          this.fetchingHistoryState = RefreshButtonState.LOADING;
        } else {
          this.fetchingHistoryState = RefreshButtonState.SUCCESS;
          setTimeout(
            () => (this.fetchingHistoryState = RefreshButtonState.IDLE),
            2500
          );
        }
      });
    }
    this.store.dispatch(
      invokeRemunerationDetails({
        filter: {
          ...this.remunerationFilter,
          pager: {
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          },
        },
        refreshCache: refreshCache,
      })
    );
  }

  itemsPerPageChange(pageSize: number) {
    this.pageSize = pageSize;
    this.pageNumber = 1;
    this.remunerationFilter = {
      ...this.remunerationFilter,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      },
    };
    this.filterData(false);
  }

  changePage(event: number) {
    this.pageNumber = event;
    this.remunerationFilter = {
      ...this.remunerationFilter,
      pager: {
        ...this.remunerationFilter.pager,
        pageNumber: event,
      },
    };
    this.filterData(false);
  }

  columnFilterChange(event: any) {
    this.remunerationFilter = {
      ...this.remunerationFilter,
    };
    this.filterData(false);
  }

  saveOption(
    action: ActionReturned,
    lp: RemunerationDetailsResponse,
    advertisingCampaigns: AdvertisingCampaignRemunerationDetails[]
  ) {
    switch (action.option.type) {
      case OptionActionEnum.ADMIN_UPDATE_LOCATION_PAYMENT_STATUS: {
        const modalRef = this.modalService.open(UpdatePaymentStatusComponent, {
          centered: true,
        });
        modalRef.componentInstance.companyName = lp.companyName;
        modalRef.componentInstance.title =
          "enumMapping.paymentLP.updatePaymentStatus";
        modalRef.componentInstance.dateRange = [
          this.formFilter.get("date")?.value[0],
          this.formFilter.get("date")?.value[1],
        ];
        modalRef.componentInstance.isPaid = this.isPaid;
        modalRef.componentInstance.companyNameFilter =
          this.formFilter.get("companyName")?.value;
        modalRef.componentInstance.advertisingCampaigns = advertisingCampaigns;

        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.PATCH,
          UserHistoryServicesEnum.UPDATE_LOCATION_PAYMENT_STATUS
        );
        break;
      }
    }
  }

  findOption(option: any | null) {
    const KeyFound = Object.keys(PaymentStatusToShow).find(
      (key) => PaymentStatusToShow[key as PaymentStatus] === option
    );
    switch (KeyFound) {
      case PaymentStatus.PAID:
        this.isPaid = true;
        break;
      case PaymentStatus.UNPAID:
        this.isPaid = false;
        break;
      default:
        this.isPaid = null;
    }
    return this.isPaid;
  }
  saveOptionFilter(option: any | null) {
    this.pageNumber = 1;
    this.isPaid = this.findOption(option);
    this.remunerationFilter = {
      ...this.remunerationFilter,
      isPaid: this.isPaid,
      pager: {
        ...this.remunerationFilter.pager,
        pageNumber: this.pageNumber,
      },
    };
    this.filterData(false);
  }

  showTooltip(remunerationStatus: RemunerationEnum): boolean {
    return UtilFunctions.showTooltip(remunerationStatus);
  }

  getRevenueTooltip(
    paidImpressions: number,
    paidPeriodStart: Date,
    paidPeriodEnd: Date
  ): string {
    return UtilFunctions.getRevenueTooltip(
      paidImpressions,
      paidPeriodStart,
      paidPeriodEnd,
      this.translate,
      this.datePipe
    );
  }
}
